import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export class EicCodeValidator {

    public static readonly EIC_CODE_LENGTH: number = 16;
    public static readonly AMOUNT_OF_ALLOWED_CHARACTERS: number = 37;
    static ALLOWED_CHARACTERS = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        '-',
    ];

    static validate(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            const minLength = Validators.minLength(this.EIC_CODE_LENGTH)(control);
            if (minLength !== null) {
                return minLength;
            }

            const maxLength = Validators.maxLength(this.EIC_CODE_LENGTH)(control);
            if (maxLength !== null) {
                return maxLength;
            }

            const invalidCharacters = this.findInvalidCharacters(control.value.toString());
            if (invalidCharacters !== null) {
                return {
                    invalidCharacters: {
                        amount: invalidCharacters.length,
                        characters: invalidCharacters,
                    },
                };
            }

            if (!this.isCheckCharValid(control.value.toString())) {
                return { checkCharInvalid: true };
            }

            return null;
        };
    }

    static findInvalidCharacters(eicCandidate: string): string[] | null {
        const eicCandidates = eicCandidate.split('');
        const invalidCharracters = eicCandidates.filter(c => this.ALLOWED_CHARACTERS.indexOf(c) === -1);
        return invalidCharracters.length > 0 ? invalidCharracters : null;
    }

    static isCheckCharValid(eicCandidate: string): boolean {
        const calculatedCheckSum = this.calcCheckChar(eicCandidate.substring(0, this.EIC_CODE_LENGTH - 1));
        const currentCheckChar = eicCandidate[this.EIC_CODE_LENGTH - 1];
        return calculatedCheckSum == currentCheckChar;
    }

    static calcCheckChar(eicCandidate: string): string {
        const sum = eicCandidate.split('')
            .map((character, index) => this.weighting(this.ALLOWED_CHARACTERS.indexOf(character), index))
            .reduce((accumulator, current) => accumulator + current, 0);

        const modCalcIndex = (36 - ((sum - 1) % this.AMOUNT_OF_ALLOWED_CHARACTERS));
        return this.ALLOWED_CHARACTERS[modCalcIndex];
    }

    public static weighting(x, index) {
        return (this.EIC_CODE_LENGTH - index) * x;
    }
}


